const LOCATIONS = [
  {
    city: 'Oakville',
    region: 'GTA West',
    phone: '(905) 845-4009',
    tel: '9058454009',
    address: '6-1200 Speers Road, Oakville, ON L6L 2X4',
    desc: 'Our head office and primary service hub. Specialists in condo HVAC regulations, heritage home conversions, and energy-efficient upgrades throughout Oakville.',
    highlights: ['Head Office Location', 'Furnace & AC', 'Air Quality', 'Duct Cleaning'],
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2903.1!2d-79.7!3d43.45!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b5b1e3c5fffff%3A0x1!2s6-1200+Speers+Road+Oakville+ON!5e0!3m2!1sen!2sca!4v1',
  },
  {
    city: 'Burlington',
    region: 'GTA West',
    phone: '(905) 845-4009',
    tel: '9058454009',
    address: 'Burlington, ON',
    desc: 'Comprehensive residential and commercial HVAC service across Burlington — from downtown to the lakeshore communities and beyond.',
    highlights: ['Residential HVAC', 'Commercial Service', '24/7 Emergency', 'Free Consultation'],
    mapSrc: '',
  },
  {
    city: 'Mississauga',
    region: 'GTA West',
    phone: '(905) 845-4009',
    tel: '9058454009',
    address: 'Mississauga, ON',
    desc: 'Full-service HVAC installations, maintenance, and emergency repairs for Mississauga homeowners and businesses of all sizes.',
    highlights: ['Installation', 'Maintenance', 'Emergency Repair', 'Air Quality'],
    mapSrc: '',
  },
  {
    city: 'Toronto',
    region: 'GTA East',
    phone: '(416) 891-3444',
    tel: '4168913444',
    address: 'Toronto, ON',
    desc: 'Urban HVAC expertise for Toronto\'s high-density condos, older city homes, and commercial properties. Specialists in condo board compliance.',
    highlights: ['Condo HVAC', 'Older Homes', 'Emergency Service', 'Air Quality'],
    mapSrc: '',
  },
  {
    city: 'Etobicoke',
    region: 'GTA East',
    phone: '(416) 891-3444',
    tel: '4168913444',
    address: 'Etobicoke, ON',
    desc: 'Reliable HVAC solutions for Etobicoke residential and commercial properties — fast response times and certified expert technicians.',
    highlights: ['Fast Response', 'All Brands', 'Installation', 'Maintenance'],
    mapSrc: '',
  },
  {
    city: 'Waterdown',
    region: 'GTA West',
    phone: '(905) 845-4009',
    tel: '9058454009',
    address: 'Waterdown, ON',
    desc: 'Serving the growing Waterdown community with professional heating, cooling, and air quality solutions from our nearby GTA West team.',
    highlights: ['Residential HVAC', 'New Builds', 'Maintenance', 'Emergency'],
    mapSrc: '',
  },
];

export default function LocationsGrid() {
  return (
    <div>
      {/* Google Map - Oakville Head Office */}
      <section className="bg-luxury-black">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
          <div className="text-center mb-10">
            <span className="font-caps text-[11px] tracking-[0.25em] uppercase text-luxury-gold/60 block mb-3">Head Office</span>
            <h2 className="font-serif text-3xl lg:text-4xl text-luxury-off-white mb-3">
              Oakville, Ontario
            </h2>
            <p className="font-sans text-sm text-luxury-off-white/40">6-1200 Speers Road, Oakville, ON L6L 2X4</p>
          </div>
          <div className="rounded-3xl overflow-hidden border border-luxury-gold/15" style={{ height: '400px' }}>
            <iframe
              title="Atlantis HVAC Systems Head Office - Oakville ON"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2898.6!2d-79.726!3d43.418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b61ae1a99d38b%3A0x1a8a9a9a9a9a9a9a!2s1200+Speers+Rd%2C+Oakville%2C+ON+L6L+2X4!5e0!3m2!1sen!2sca!4v1700000000000!5m2!1sen!2sca"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'grayscale(30%) contrast(110%)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      {/* Location Cards */}
      <section className="bg-luxury-cream py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <span className="font-caps text-[11px] tracking-[0.25em] uppercase text-luxury-text-muted block mb-4">All Service Areas</span>
            <h2 className="font-serif text-3xl lg:text-5xl text-luxury-text-dark leading-tight">
              Wherever You Are <br />
              <em className="not-italic text-luxury-gold-dark">in the GTA</em>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {LOCATIONS.map((loc) => (
              <div
                key={loc.city}
                className="bg-white rounded-2xl overflow-hidden border border-luxury-gold/10 hover:border-luxury-gold/25 transition-all duration-300 group"
              >
                {/* Card Header */}
                <div className="bg-luxury-dark px-6 py-5 flex items-center justify-between">
                  <div>
                    <h3 className="font-serif text-luxury-off-white text-xl font-semibold">{loc.city}</h3>
                    <span className="font-caps text-[10px] tracking-widest text-luxury-gold/60 uppercase">{loc.region}</span>
                  </div>
                  <div className="w-9 h-9 flex items-center justify-center rounded-full border border-luxury-gold/20">
                    <i className="ri-map-pin-2-line text-luxury-gold text-sm" />
                  </div>
                </div>

                <div className="p-6">
                  <p className="font-sans text-sm text-luxury-text-muted leading-relaxed mb-5">{loc.desc}</p>
                  <div className="flex flex-wrap gap-1.5 mb-5">
                    {loc.highlights.map((h) => (
                      <span key={h} className="font-caps text-[10px] tracking-wide text-luxury-gold/70 bg-luxury-gold/8 border border-luxury-gold/15 px-2.5 py-1 rounded-full whitespace-nowrap">
                        {h}
                      </span>
                    ))}
                  </div>
                  <a
                    href={`tel:${loc.tel}`}
                    className="inline-flex items-center gap-2 bg-luxury-gold hover:bg-luxury-gold-light text-luxury-black font-caps font-semibold text-xs tracking-[0.1em] uppercase px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-phone-fill text-xs" />
                    </div>
                    <span>{loc.phone}</span>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Post-areas CTA */}
          <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-5">
            <div className="bg-luxury-dark rounded-2xl p-7 flex items-center gap-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-full border border-luxury-gold/25 flex-shrink-0">
                <i className="ri-phone-fill text-luxury-gold text-lg" />
              </div>
              <div>
                <span className="font-caps text-[10px] tracking-widest text-luxury-gold/60 uppercase block mb-1 whitespace-nowrap">GTA West — Oakville / Burlington / Mississauga</span>
                <a href="tel:9058454009" className="font-serif text-luxury-gold text-2xl font-bold cursor-pointer hover:text-luxury-gold-light transition-colors whitespace-nowrap">
                  (905) 845-4009
                </a>
              </div>
            </div>
            <div className="bg-luxury-dark rounded-2xl p-7 flex items-center gap-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-full border border-luxury-gold/25 flex-shrink-0">
                <i className="ri-phone-fill text-luxury-gold text-lg" />
              </div>
              <div>
                <span className="font-caps text-[10px] tracking-widest text-luxury-gold/60 uppercase block mb-1 whitespace-nowrap">GTA East — Toronto / Etobicoke</span>
                <a href="tel:4168913444" className="font-serif text-luxury-gold text-2xl font-bold cursor-pointer hover:text-luxury-gold-light transition-colors whitespace-nowrap">
                  (416) 891-3444
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
